import React from 'react';

import { DescriptionsProps } from 'antd/lib/descriptions';

import * as Styled from './DescriptionsContainer.style';

export type Props = DescriptionsProps;

export const DescriptionsContainer = (props: Props): JSX.Element => <Styled.Descriptions {...props} />;
